import { PrismaClient } from '@prisma/client'

const globalForPrisma = globalThis as unknown as {
  prisma: PrismaClient | undefined
}

// PrismaClient is lazy by default - it only connects when queries are made
// During Next.js build, we don't need database connections, so we can safely
// create the client even if DATABASE_URL is not set or unreachable
export const db =
  globalForPrisma.prisma ??
  new PrismaClient({
    log: process.env.NODE_ENV === 'development' ? ['query'] : [],
    // Prevent Prisma from trying to connect during build
    // Connection will only happen when queries are actually executed
  })

if (process.env.NODE_ENV !== 'production') globalForPrisma.prisma = db